import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { RedbookVehiclePhoto } from "../../types/Vehicles";

export const getQuoteVehicleImages = (quoteId: string) => {
  const { fetchWithAuth } = useApi();

  return useQuery({
    queryKey: ["quote-vehicle-images", quoteId],
    queryFn: (): Promise<RedbookVehiclePhoto[]> => {
      return fetchWithAuth<RedbookVehiclePhoto[]>(
        "getQuoteVehicleImages",
        quoteId
      );
    },
  });
};
